import { MapPin, Mail, ArrowUp, Clock4 } from "lucide-react";
import { CLINIC } from "../data/content";
import { scrollToId } from "../lib/scroll";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="grain relative overflow-hidden bg-[#03060A] text-ivory"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -left-32 top-0 h-[360px] w-[360px] rounded-full bg-toothcyan/10 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 bottom-10 h-[320px] w-[320px] rounded-full bg-ember/10 blur-3xl"
      />

      <div className="relative mx-auto max-w-7xl px-5 pt-16 sm:px-8 sm:pt-20">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="flex items-center gap-4">
            <span className="rounded-2xl bg-white p-1.5 shadow-lg shadow-black/40">
              <img
                src={CLINIC.logo}
                alt="Narayan Dental Care logo"
                className="h-12 w-12 rounded-xl object-contain"
              />
            </span>
            <div>
              <div className="font-serif text-lg font-semibold">
                {CLINIC.name}
              </div>
              <div className="font-mono text-[9px] uppercase tracking-[0.26em] text-ember">
                {CLINIC.tagline}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2.5 text-sm text-ivory/70">
            <span className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-ember" />
              {CLINIC.address}
            </span>
            <a
              href={`mailto:${CLINIC.email}`}
              className="flex items-center gap-2.5 transition-colors hover:text-ember"
            >
              <Mail className="h-4 w-4 shrink-0 text-ember" />
              {CLINIC.email}
            </a>
            <span className="flex items-center gap-2.5">
              <Clock4 className="h-4 w-4 shrink-0 text-ember" />
              Mon – Sat 11:00 AM – 8:00 PM · Sun on appointment
            </span>
          </div>

          <button
            data-testid="footer-back-to-top-button"
            onClick={() => scrollToId("#top")}
            className="group flex items-center gap-2 rounded-full border border-ivory/20 px-5 py-2.5 text-xs font-semibold text-ivory/80 transition-all duration-200 hover:border-ember hover:text-ember"
          >
            Back to top
            <ArrowUp className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5" />
          </button>
        </div>

        <div
          aria-hidden
          className="pointer-events-none mt-14 select-none overflow-hidden"
        >
          <div className="text-stroke-ivory whitespace-nowrap text-center font-serif text-[13.5vw] font-semibold leading-[0.9] tracking-tight">
            Narayan Dental
          </div>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-ivory/10 py-6 font-mono text-[10px] uppercase tracking-[0.18em] text-ivory/40 sm:flex-row sm:items-center">
          <span>
            © {new Date().getFullYear()} {CLINIC.name} · {CLINIC.doctorHonorific}
          </span>
          <span>Saheed Nagar · Bhubaneswar · Odisha</span>
        </div>
      </div>
    </footer>
  );
}
